import { lazyConRecarga } from '../lib/recargaPorDeploy';
import { Suspense } from 'react';
import { type RouteObject } from 'react-router-dom';
import { Spinner } from './routes.shared';

/**
 * El portal del propietario, compartido por el sitio público de Imperium y la web de Booster.
 *
 * Desde que las apps se separaron (ebb69a4) solo lo montaba el sitio de Imperium: en
 * boostercrm.app el mail de acceso y el link por WhatsApp caían en el login del CRM, así
 * que ningún dueño de una inmobiliaria Booster podía entrar a su portal. (Grabando los
 * tutoriales de Booster, 28/10/2026)
 */
// Owner Portal
const OwnerPortalLayout      = lazyConRecarga(() => import('../features/ownerPortal/OwnerPortalLayout').then(m => ({ default: m.OwnerPortalLayout })));
const OwnerLoginPage         = lazyConRecarga(() => import('../features/ownerPortal/OwnerLoginPage').then(m => ({ default: m.OwnerLoginPage })));
const OwnerVerifyPage        = lazyConRecarga(() => import('../features/ownerPortal/OwnerVerifyPage').then(m => ({ default: m.OwnerVerifyPage })));
const OwnerDashboardPage     = lazyConRecarga(() => import('../features/ownerPortal/OwnerDashboardPage').then(m => ({ default: m.OwnerDashboardPage })));
const OwnerPropertyDetailPage = lazyConRecarga(() => import('../features/ownerPortal/OwnerPropertyDetailPage').then(m => ({ default: m.OwnerPropertyDetailPage })));
const OwnerAuctionsPage      = lazyConRecarga(() => import('../features/ownerPortal/OwnerAuctionsPage').then(m => ({ default: m.OwnerAuctionsPage })));
const OwnerTasacionesPage    = lazyConRecarga(() => import('../features/ownerPortal/OwnerTasacionesPage').then(m => ({ default: m.OwnerTasacionesPage })));
const OwnerAgentPage         = lazyConRecarga(() => import('../features/ownerPortal/OwnerAgentPage').then(m => ({ default: m.OwnerAgentPage })));
const OwnerTasacionReportPage = lazyConRecarga(() => import('../features/ownerPortal/OwnerTasacionReportPage').then(m => ({ default: m.OwnerTasacionReportPage })));
const OwnerMarketplacePage   = lazyConRecarga(() => import('../features/ownerPortal/OwnerMarketplacePage').then(m => ({ default: m.OwnerMarketplacePage })));

// Help (compartida con el CRM; mismo módulo → Rollup dedup del chunk)
const HelpPage = lazyConRecarga(() => import('../features/help/HelpPage').then(m => ({ default: m.HelpPage })));

export const ownerPortalRoutes: RouteObject[] = [
  { path: '/portal/login',  element: <Suspense fallback={<Spinner />}><OwnerLoginPage /></Suspense> },
  { path: '/portal/verify', element: <Suspense fallback={<Spinner />}><OwnerVerifyPage /></Suspense> },
  {
    path: '/portal',
    element: <Suspense fallback={<Spinner />}><OwnerPortalLayout /></Suspense>,
    children: [
      { index: true,                   element: <Suspense fallback={<Spinner />}><OwnerDashboardPage /></Suspense> },
      { path: 'tasaciones',            element: <Suspense fallback={<Spinner />}><OwnerTasacionesPage /></Suspense> },
      { path: 'mi-agente',             element: <Suspense fallback={<Spinner />}><OwnerAgentPage /></Suspense> },
      { path: 'tasacion/:id',          element: <Suspense fallback={<Spinner />}><OwnerTasacionReportPage /></Suspense> },
      { path: 'subastas',              element: <Suspense fallback={<Spinner />}><OwnerAuctionsPage /></Suspense> },
      { path: 'beneficios',            element: <Suspense fallback={<Spinner />}><OwnerMarketplacePage /></Suspense> },
      { path: 'propiedad/:id',         element: <Suspense fallback={<Spinner />}><OwnerPropertyDetailPage /></Suspense> },
      { path: 'ayuda',                 element: <Suspense fallback={<Spinner />}><HelpPage forcedRole="property_owner" /></Suspense> },
    ],
  },
];
